@if (phase_track_items().length === 0) {
  <p class="muted">No hay fases configuradas en la vacante.</p>
} @else {
  <div class="phase-timeline" role="list">
    @for (phase_track_item of phase_track_items(); track phase_track_item.phase_id; let is_last = $last) {
      <div
        class="phase-timeline-step phase-candidate-state-{{ phase_track_item.state }}"
        role="listitem"
        [matTooltip]="phase_track_item.tooltip"
        matTooltipClass="phase-timeline-tooltip"
      >
        <div class="phase-timeline-node">
          @if (!is_last) {
            <span class="phase-timeline-connector" aria-hidden="true"></span>
          }
          <span class="phase-timeline-circle">
            <mat-icon aria-hidden="true">{{ phase_track_item.icon }}</mat-icon>
          </span>
          @if (phase_track_item.state === 'current') {
            <span class="phase-timeline-indicator" aria-hidden="true"></span>
          }
        </div>
        <p class="phase-timeline-name">{{ phase_track_item.name }}</p>
        <p class="phase-timeline-stats">{{ phase_track_item.status_label }}</p>
      </div>
    }
  </div>
}
